import type Variant from '@modules/product/type/variant';
import type { PriceUnitEnum, ProductPricingTypeEnum } from 'generated/graphql';
import { isEcomPriceType } from './is-ecom-price-type';
import type CurrencyAmount from '../type/currency-amount';

interface VariantPriceType {
    isOnSale: boolean;
    isPriceRange: boolean;
    price: CurrencyAmount;
    retailPrice: CurrencyAmount;
    maxPrice: CurrencyAmount;
    priceUnit?: PriceUnitEnum | null;
    hasPrice: boolean;
}

export const makeVariantPrice = (
    hasPrice: boolean,
    selectedVariant: Variant | null,
    pricingType: ProductPricingTypeEnum,
): VariantPriceType => {
    const result: VariantPriceType = {
        hasPrice,
        isOnSale: false,
        isPriceRange: false,
        price: {
            Amount: 0,
            ShortFormat: '',
            Currency: '',
        },
        retailPrice: {
            Amount: 0,
            ShortFormat: '',
        },
        maxPrice: {
            Amount: 0,
            ShortFormat: '',
        },
        priceUnit: null,
    };

    if (selectedVariant) {
        result.isPriceRange =
            !isEcomPriceType(pricingType) &&
            hasPrice &&
            selectedVariant.Price.Amount !== selectedVariant.MaxPrice.Amount;
        result.isOnSale =
            selectedVariant.PriceType === 'SALE' ||
            selectedVariant.RetailPrice.Amount > selectedVariant.Price.Amount;
        result.price = selectedVariant.Price;
        result.retailPrice = selectedVariant.RetailPrice;
        result.maxPrice = selectedVariant.MaxPrice;
        result.priceUnit = selectedVariant.PriceUnit;
    }

    return result;
};
